import $$ from 'cmn-utils'
const BaseUrl = "/api/linkage/v2/trigger/";
export default {
    list: (params) => {
        return $$.get(BaseUrl + `list`, params);
    },
    delete: (params) => {
        return $$.post(BaseUrl + `delete`, params);
    },
    create: (params) => {
        const { eventList } = params
        delete params.eventList
        if (eventList && eventList.length > 0) {
            eventList.forEach((element, index) => {
                if (element) {
                    params['eventList[' + index + "].eventCode"] = element.eventCode;
                }
            });
        }
        return $$.post(BaseUrl + `create`, params);
    },
    selectList: (params) => {
        return $$.get(BaseUrl + `event/select-list`, params);
    },
}